import React from 'react';
import { Link } from "react-router-dom";
import '../../styles/admin-page.css';
import MANAGER from '../../images/2202112.png';
import { useState } from "react";
import ControlsPage from "./ControlsPage";
import ClientsPage from "./ClientsPage";
import EmployeesTotalData from "./EmployeesTotalData";
import VehiclesTotalData from "./VehiclesTotalData";

const AdminPage = ({
  controls,
  handleCurrentControls,
  currentControls,
  handleClientInfo
}) => {

  const [currentPage, setCurrentPage] = useState('login');

  const handleLogin = (e) => {
    if (e.target.value === controls.adminPassword) {
      setCurrentPage('adminHomePage');
    }
  }

  const handleCurrentPage = (pageName) => {
    setCurrentPage(pageName);
  }

  return (
    <section className="admin-page">
      {(currentPage === 'login' || currentPage === 'adminHomePage') &&
        <>
        <section className="admin-page-links">
          <Link to='/delivery-assistant/' className="back-arrow" title="orders page">⟰</Link>
        </section>
        <img className="manager-photo" src={MANAGER} alt='manager'/>
        <h1 className="title">Welcome</h1>
        </>}
      {currentPage === 'login' &&
      <form className="login-form">
        <h2>Log in to resume</h2>
        <input 
          className='choose-em' 
          type='password' 
          placeholder='demo password 1 ' 
          onChange={handleLogin}  
        />
      </form>}
      
      {currentPage === 'adminHomePage' &&
      <section className="admin-home-links">
        <div>
          <p>Controls Page :</p> 
          <button onClick={() => handleCurrentPage('controls')}>Open</button>
        </div>
        <hr />
        <div>
          <p>Employees Data Page :</p> 
          <button onClick={() => handleCurrentPage('employees-data')}>Open</button>
        </div>
        <hr />
        <div>
          <p>Vehicles Data Page :</p> 
          <button onClick={() => handleCurrentPage('vehicles-data')}>Open</button>
        </div>
        <hr />
        <div>
          <p>Clients Data Page :</p> 
          <button onClick={() => handleCurrentPage('clients-data')}>Open</button>
        </div>
      </section>
      }

      {currentPage === 'controls' && 
      <ControlsPage 
        controls={controls}
        handleCurrentControls={handleCurrentControls}
        handleCurrentPage={handleCurrentPage}
      />
      }
      {currentPage === 'employees-data' && 
      <EmployeesTotalData 
        handleCurrentPage={handleCurrentPage}
        currentControls={currentControls}
      />
      }
      {currentPage === 'vehicles-data' && 
      <VehiclesTotalData
        handleCurrentPage={handleCurrentPage}
        currentControls={currentControls}
      />
      }
      {currentPage === 'clients-data' && 
      <ClientsPage
        handleCurrentPage={handleCurrentPage}
        handleClientInfo={handleClientInfo}
      />
      }
    </section>
  )
}

export default AdminPage;